import { render, staticRenderFns } from "./shopbill.vue?vue&type=template&id=f89a1430&scoped=true&"
import script from "./shopbill.vue?vue&type=script&lang=js&"
export * from "./shopbill.vue?vue&type=script&lang=js&"
import style0 from "./shopbill.vue?vue&type=style&index=0&id=f89a1430&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89a1430",
  null
  
)

export default component.exports